import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
  EditableItem,
  EditListModalBase,
  EditListSchema,
} from '../../../../shared/bases/edit-list-modal.base';
export interface TimeBasedWorkProposition extends EditableItem {
  periodicity: string;
}

@Component({
  selector: 'app-edit-operations-maintenance-modal',
  templateUrl: './edit-operations-maintenance-modal.component.html',
  styleUrls: ['./edit-operations-maintenance-modal.component.scss'],
  standalone: false,
})
export class EditOperationsMaintenanceModalComponent extends EditListModalBase<TimeBasedWorkProposition> {
  @Output() onSubmitForm = new EventEmitter<any>();
  @Output() onCancelForm = new EventEmitter<void>();

  periodicityOptions = [
    { label: 'Hebdomadaire', value: 'hebdomadaire' },
    { label: 'Mensuelle', value: 'mensuelle' },
    { label: 'Trimestrielle', value: 'trimestrielle' },
    { label: 'Semestrielle', value: 'semestrielle' },
    { label: 'Non spécifiée', value: 'non spécifiée' },
  ];

  constructor(
    fb: FormBuilder,
    confirmationService: ConfirmationService,
    private messageService: MessageService,
  ) {
    super(
      fb,
      {
        arrayName: 'operationsMaintenance',
        confirmDeleteHeader: 'Confirmation de suppression',
        confirmDeleteMessage:
          'Êtes-vous sûr de vouloir supprimer cette opération de maintenance ?',
        fields: {
          periodicity: {
            defaultValue: '',
            validators: [Validators.required, Validators.minLength(1)],
            trackOriginal: true,
          },
        },
      } as EditListSchema<TimeBasedWorkProposition>,
      confirmationService,
    );
  }

  onSubmit(): void {
    if (!this.isFormValid) {
      this.messageService.add({
        key: this.CONFIRM_DELETE,
        severity: 'error',
        summary: 'Erreur',
        detail: this.validationMessage,
      });
      return;
    }
    this.onSubmitForm.emit(this.buildSubmitResult());
    this.closeModal();
  }

  onCancel(): void {
    this.onCancelForm.emit();
    this.closeModal();
  }
}
